import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  colors: {
    background: 'linear-gradient(#ffff00, #ffbb00, #ff0000, #000000)',
    marginBottom: "5px",
  },

  colors2: {
    background: 'linear-gradient(#528E54, #000000)',
    marginBottom: "5px",
  },

  colors3: {
    background: 'linear-gradient(#E7F0D6, #6493C8, #000000)',
    marginBottom: "5px",
  },
}));

//Map2 Legend

const Legend = () => {
    const classes = useStyles();

  return (
    <div>
    
      <div className="legend2">
        <p align="center">Agricultural</p>
        <Grid container>
          <Grid item xs={4} className={classes.colors2}>
            <div
              className={classes.colors2}
              style={{
                background:
                  "linearGradient(#ffff00, #ffbb00, #ff0000, #000000)",
              }}
            ></div>
          </Grid>
          <Grid item xs={8}>
            <div>
              <div>
                <span></span>
                <span>High</span>
                <span></span>
              </div>
              <div>
                <span></span>
              </div>
              <div>
                <span></span>
              </div>
              <div>
                <span></span>
              </div>
              <div>
                <span></span>
              </div>
              <div>
                <span></span>
              </div>
              <div>
                <span></span>
              </div>
              <div>
                <span></span>
                <span>Low</span>
                <span></span>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

    </div>
  );
};

export default Legend;